<template>
  <div v-if="visible" :class="['alert', `alert--${type}`]">
    <div class="alert__icon">
      <icon-base :icon-name="iconName" :width="24" :height="24" />
    </div>
    <div class="alert__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import IconBase from './Icons/IconBase.vue'

export default {
  name: 'Alert',
  components: {
    IconBase,
  },
  props: {
    type: {
      type: String,
      default: 'info',
      validator: value => ['success', 'info', 'delete', 'warn'].includes(value),
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    iconName() {
      const iconMap = {
        info: 'info',
        success: 'success',
        warn: 'warning',
        delete: 'delete',
      }
      return iconMap[this.type] || 'info'
    },
  },
}
</script>

<style lang="scss" scoped>
.alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: $border-radius-md;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -1%;

  &__icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    flex: 1;
    color: $color-default;
  }

  &--info {
    background-color: $notification-information-color;

    .alert__icon {
      color: $notification-information-icon-color;
    }
  }

  &--success {
    background-color: $notification-success-color;

    .alert__icon {
      color: $notification-success-icon-color;
    }
  }

  &--warn {
    background-color: $notification-warning-color;

    .alert__icon {
      color: $notification-warning-icon-color;
    }
  }

  &--delete {
    background-color: $notification-error-color;

    .alert__icon {
      color: $notification-error-icon-color;
    }
  }
}
</style>
